// The color choices offered to households: single colors and palettes. Shared
// by "My house" (own show) and the light board, so both offer the same ones.
import type { Rgb } from "../shared/protocol.ts";
import { HALLOWEEN } from "./site.ts";

const CHRISTMAS_COLORS: [string, Rgb][] = [
  ["Red", [255, 0, 0]],
  ["Green", [0, 200, 40]],
  ["Gold", [255, 140, 0]],
  ["Warm white", [255, 170, 80]],
  ["Icy blue", [0, 120, 255]],
  ["Purple", [140, 0, 255]],
];

const CHRISTMAS_PALETTES: [string, Rgb[]][] = [
  ["Classic red and green", [[255, 0, 0], [0, 200, 40]]],
  ["Candy cane", [[255, 0, 0], [255, 255, 255]]],
  ["Gold and white", [[255, 140, 0], [255, 220, 170]]],
  ["Icy", [[0, 60, 255], [200, 230, 255], [0, 200, 255]]],
  ["Rainbow", [[255, 0, 0], [255, 140, 0], [255, 230, 0], [0, 200, 40], [0, 60, 255], [140, 0, 255]]],
];

// Offered first while the site look is Halloween (the first one is the default).
export const HALLOWEEN_COLORS: [string, Rgb][] = [
  ["Pumpkin orange", [255, 70, 0]],
  ["Slime green", [80, 255, 0]],
];

export const HALLOWEEN_PALETTES: [string, Rgb[]][] = [
  ["Halloween orange and purple", [[255, 70, 0], [140, 0, 255]]],
  ["Candy corn", [[255, 70, 0], [255, 190, 0], [255, 230, 200]]],
  ["Witch's brew", [[140, 0, 255], [80, 255, 0]]],
  ["Pumpkin patch", [[255, 70, 0], [255, 120, 0], [0, 160, 20]]],
];

export const COLORS = HALLOWEEN ? [...HALLOWEEN_COLORS, ...CHRISTMAS_COLORS] : CHRISTMAS_COLORS;
export const PALETTES = HALLOWEEN ? [...HALLOWEEN_PALETTES, ...CHRISTMAS_PALETTES] : CHRISTMAS_PALETTES;

export function css(c: Rgb): string {
  return `rgb(${c[0]}, ${c[1]}, ${c[2]})`;
}
